import React, { useState } from "react";
import { Text, Img, List, Button, Line } from "components";
import { useTranslation } from "react-i18next";
import EmptyListOrder from "../EmptyListOrder";
import { useNavigate } from "react-router-dom";
import globalRequest from "../../../../utils/global/globalRequest";
import { useDispatch } from "react-redux";
import { changeLoader } from "../../../../redux/reducers/loader";
import * as CUSTOM from "../../../../utils/helper/custom";
import * as APIS from "../../../../utils/helper/Enum";
import { useEffect } from "react";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";

let statusIgnoreArray = [
  "no_show",
  "cancelled",
  "rejected",
  "placed",
];

const MyOrdersOrderlist = () => {
  const { t } = useTranslation();
  let dispatch = useDispatch();
  const navigate = useNavigate();
  const [orderData, setOrderData] = useState([]);
  let [apiLoadStatus, setApiLoadStatus] = useState(true);
  const [inputData, setInputData] = useState({ page: 1, limit: 10 });
  const [isPagination, setIsPagination] = useState(true);
  const [trackHistoryModal, setTrackHistoryModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);

  /**
   * get my orders
   */
  const getMyOrders = async () => {
    let orderDataArray = [];
    dispatch(changeLoader(true));
    apiLoadStatus = true;
    try {
      let response = await globalRequest(
        APIS?.ORDER?.MY_ORDER_LISTING,
        "get",
        {},
        { params: inputData },
        true
      );
      response = response?.data;
      if (response?.status == "SUCCESS") {
        orderDataArray = response?.data?.data;
        setOrderData((pre) => [...pre, ...orderDataArray]);
        setIsPagination(orderDataArray.length ? true : false);
      } else {
        setIsPagination(false);
      }
    } catch (e) {}
    apiLoadStatus = false;
    setApiLoadStatus(apiLoadStatus);
    dispatch(changeLoader(false));
  };

  const getOrderItemNames = (id) => {
    const oData = orderData.find((item) => item?.id == id);
    if (!oData) {
      return ""; // Return an empty string if order data is not found
    }
    if (
      oData.orderType === "custom_cake" ||
      oData.orderType === "custom_cake_gift"
    ) {
      return `1 X ${t("cake")}`;
    }
    const proData = oData.orderDetails.map((item) => {
      const { quantity, orderItemDetails } = item;
      const { product } = orderItemDetails || {};
      const productName = CUSTOM.getdataByLangKey(
        product?.productLocales,
        "",
        "name"
      );
      return `${quantity} X ${productName || ""}`;
    });
    return proData.join(", ");
  };

  /**
   * Get product images from order
   */
  const getOrderImages = (order) => {
    if (order.orderType === "custom_cake" || order.orderType === "custom_cake_gift") {
      const imageLinks = order.orderDetails[0]?.orderItemDetails?.imageLinks || [];
      return imageLinks.slice(0, 1);
    } else {
      return order.orderDetails.slice(0, 1).map(item => {
        const product = item?.orderItemDetails?.product;
        return product?.imageUrl || product?.image || "/images/placeholder-cake.png";
      });
    }
  };

  /**
   * Get product details with individual prices
   */
  const getOrderProductDetails = (order) => {
    if (order.orderType === "custom_cake" || order.orderType === "custom_cake_gift") {
      const details = order.orderDetails[0]?.orderItemDetails;
      const cakeDetail = details?.cakeDetail || [];
      
      const modifiers = [];
      cakeDetail.forEach(modifier => {
        const modifierItems = modifier?.modifierGroupItems || [];
        modifierItems.forEach(item => {
          const itemName = CUSTOM.getdataByLangKey(
            item?.modifierGroupItemLocales,
            "",
            "name"
          );
          if (itemName) {
            modifiers.push(itemName);
          }
        });
      });
      
      return [{
        name: "Custom Cake",
        description: modifiers.join(", ") || "Custom Design",
        quantity: 1,
        price: order.priceDetails?.sub_total
      }];
    } else {
      return order.orderDetails.map(item => {
        const { quantity, orderItemDetails } = item;
        const { product } = orderItemDetails || {};
        const productName = CUSTOM.getdataByLangKey(
          product?.productLocales,
          "",
          "name"
        );
        return {
          name: productName || "Product",
          description: "",
          quantity: quantity,
          price: orderItemDetails?.price || 0
        };
      });
    }
  };

  /**
   * Get order type display
   */
  const getOrderTypeDisplay = (order) => {
    if (order.orderType === "custom_cake" || order.orderType === "custom_cake_gift") {
      return "Custom Cake";
    }
    return CUSTOM.ucFirst(order.orderType?.replace(/_/g, " ") || "Order");
  };

  /**
   * Get item count
   */
  const getItemCount = (order) => {
    return order.orderDetails?.length || 0;
  };

  /**
   * Get delivery address
   */
  const getDeliveryAddress = (order) => {
    const address = order.deliveryAddress;
    if (!address) return "Address not available";
    
    const parts = [];
    if (address.buildingName) parts.push(address.buildingName);
    if (address.street) parts.push(address.street);
    if (address.district) parts.push(address.district);
    if (address.city) parts.push(address.city);
    
    return parts.join(", ") || "Address not available";
  };

  /**
   * Get card message
   */
  const getCardMessage = (order) => {
    if (order.orderType === "custom_cake" || order.orderType === "custom_cake_gift") {
      const textOnCake = order.orderDetails[0]?.orderItemDetails?.textOnCake;
      return textOnCake || "";
    }
    return order.cardMessage || "";
  };

  /**
   * Get status color
   */
  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
      case "in_progress":
        return "text-orange-600";
      case "completed":
      case "delivered":
        return "text-green-600";
      case "cancelled":
        return "text-red-600";
      default:
        return "text-gray-600";
    }
  };

  /**
   * Get status display text
   */
  const getStatusText = (status) => {
    switch (status) {
      case "pending":
        return "In-Progress";
      case "in_progress":
        return "In-Progress";
      case "completed":
        return "Completed";
      case "delivered":
        return "Completed";
      case "cancelled":
        return "Cancelled";
      default:
        return CUSTOM.ucFirst(status);
    }
  };

  /**
   * Open track history modal
   */
  const openTrackHistory = (order, e) => {
    e.stopPropagation();
    setSelectedOrder(order);
    setTrackHistoryModal(true);
  };

  /**
   * Close track history modal
   */
  const closeTrackHistory = () => {
    setTrackHistoryModal(false);
    setSelectedOrder(null);
  };

  /**
   * Get order type for track history
   */
  const getTrackHistoryType = (orderType) => {
    if (orderType === "custom_cake" || orderType === "custom_cake_gift") {
      return "Custom cake";
    }
    if (orderType === "gift") {
      return "Gift";
    }
    return "regular";
  };

  /**
   * Render Track History Modal Content
   */
  const renderTrackHistory = () => {
    if (!selectedOrder) return null;

    const orderType = getTrackHistoryType(selectedOrder.orderType);
    const currentStatus = selectedOrder.status;
    const allStatuses = CUSTOM.getAllOrderStatus(orderType);

    return (
      <div className="max-h-[400px] overflow-y-auto pr-2">
        {statusIgnoreArray.indexOf(currentStatus) == -1 ? (
          <>
            {allStatuses.map((status, index) => {
              if (statusIgnoreArray.indexOf(status) !== -1) {
                return null;
              }

              const statusDate = CUSTOM.getDateFromStatusLog(
                selectedOrder?.orderStatusLogs,
                status
              );
              const isCompleted = statusDate ? true : false;

              return (
                <div
                  className="flex flex-row gap-4 items-start justify-start w-full mt-5 mb-5 relative"
                  key={`status-${index}`}
                >
                  <div
                    className={`${
                      isCompleted ? "progress-line success" : "progress-line gray"
                    }`}
                  ></div>
                  <Img
                    className="h-6 w-6 relative z-[10]"
                    src={
                      isCompleted
                        ? "/images/img_check_circle.svg"
                        : "/images/gray-dot.svg"
                    }
                    alt="status"
                  />
                  <div className="flex flex-col items-start justify-start flex-1">
                    <Text className="text-black-900 text-sm font-['Inter']">
                      {t(CUSTOM.statusByKey(status))}
                    </Text>
                    <Text className="text-gray-700 text-xs font-['Inter']">
                      {t(CUSTOM.statusMessageByKey(status))}
                    </Text>
                  </div>
                  <div className="flex flex-col items-end justify-start">
                    <Text className="text-black-900 text-sm font-['Inter'] whitespace-nowrap">
                      {isCompleted
                        ? CUSTOM.convertDateString(statusDate, "dd/MM/yyyy hh:mm a")
                        : ""}
                    </Text>
                  </div>
                </div>
              );
            })}
          </>
        ) : (
          <>
            {selectedOrder?.orderStatusLogs.map((log, index) => {
              const status = log?.status;
              if (statusIgnoreArray.indexOf(status) !== -1) {
                return null;
              }
              const statusDate = CUSTOM.getDateFromStatusLog(
                selectedOrder?.orderStatusLogs,
                status
              );

              return (
                <div
                  className="flex flex-row gap-4 items-start justify-start w-full mt-5 mb-5 relative"
                  key={`log-${index}`}
                >
                  <div className="progress-line success"></div>
                  <Img
                    className="h-6 w-6 relative z-[10]"
                    src="/images/img_check_circle.svg"
                    alt="status"
                  />
                  <div className="flex flex-col items-start justify-start flex-1">
                    <Text className="text-black-900 text-sm font-nunitomedium">
                      {t(CUSTOM.statusByKey(status))}
                    </Text>
                    <Text className="text-gray-700 text-xs font-nunitoregular">
                      {t(CUSTOM.statusMessageByKey(status))}
                    </Text>
                  </div>
                  <div className="flex flex-col items-end justify-start">
                    <Text className="text-black-900 text-sm font-nunitoregular whitespace-nowrap">
                      {CUSTOM.convertDateString(statusDate, "dd/MM/yyyy hh:mm a")}
                    </Text>
                  </div>
                </div>
              );
            })}
          </>
        )}

        {/* Show cancelled/rejected status if applicable */}
        {statusIgnoreArray.indexOf(currentStatus) !== -1 && (
          <div className="flex flex-row gap-4 items-start justify-start w-full mt-5 mb-5 relative">
            <div className="progress-line error"></div>
            <Img
              className="h-6 w-6 relative z-[10]"
              src={CUSTOM.orderStatusImgages(currentStatus)}
              alt="status"
            />
            <div className="flex flex-col items-start justify-start flex-1">
              <Text className="text-black-900 text-sm font-nunitomedium">
                {t(CUSTOM.statusByKey(currentStatus))}
              </Text>
              <Text className="text-gray-700 text-xs font-nunitoregular">
                {t(CUSTOM.statusMessageByKey(currentStatus))}
              </Text>
            </div>
            <div className="flex flex-col items-end justify-start">
              <Text className="text-black-900 text-sm font-nunitoregular whitespace-nowrap">
                {CUSTOM.convertDateString(
                  CUSTOM.getDateFromStatusLog(
                    selectedOrder?.orderStatusLogs,
                    currentStatus
                  ),
                  "dd/MM/yyyy hh:mm a"
                )}
              </Text>
            </div>
          </div>
        )}
      </div>
    );
  };

  /**
   * onscroll pagination get order
   */
  useEffect(() => {
    if (isPagination) {
      getMyOrders();
      const handleScroll = (e) => {
        const scrollHeight = e.target.documentElement.scrollHeight;
        const currentHeight =
          e.target.documentElement.scrollTop + window.innerHeight + 450;
        if (currentHeight + 1 >= scrollHeight) {
          if (!apiLoadStatus) {
            setInputData({ ...inputData, page: Number(inputData?.page) + 1 });
          }
        }
      };
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData?.page]);

  return (
    <>
      <Text className="font-['Inter'] leading-[40px] md:leading-[32px] text-2xl md:text-3xl text-black-900 mb-6">
        {t("myOrders")}
      </Text>
      <List
        className="flex flex-col font-['Inter'] gap-5 items-center w-full mb-5"
        orientation="vertical"
      >
        {orderData.map((order, index) => {
          const images = getOrderImages(order);
          const products = getOrderProductDetails(order);
          const cardMessage = getCardMessage(order);
          const deliveryAddress = getDeliveryAddress(order);
          const orderType = getOrderTypeDisplay(order);
          const itemCount = getItemCount(order);
          
          return (
            <div
              className="bg-[white] border border-gray-200 rounded-lg w-full overflow-hidden cursor-pointer hover:shadow-sm transition-shadow duration-200"
              key={`order-${order.id}-${index}`}
              onClick={() =>
                navigate(
                  `/my-order-detail/${CUSTOM.base64Encode(order.id)}`
                )
              }
            >
              {/* Order Header */}
              <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100">
                <div className="flex items-center gap-2 flex-1">
                  <Text className="text-sm font-semibold text-gray-900">
                    {order.orderNumber} ({itemCount} item{itemCount > 1 ? 's' : ''})
                  </Text>
                  
                  <Text className="text-sm text-gray-600 mx-2">
                    {orderType}
                  </Text>
                  
                  <Text className="text-sm text-gray-500">
                    {CUSTOM.convertDateString(
                      CUSTOM.getDateFromStatusLog(
                        order.orderStatusLogs,
                        order.status
                      ),
                      "MMM dd, yyyy"
                    )}
                  </Text>
                </div>

                <Text
                  className={`text-sm font-medium font-['Inter'] border border-gray-400 p-[5px] rounded-[20px] ${getStatusColor(order.status)}`}
                >
                  {getStatusText(order.status)}
                </Text>
              </div>

              {/* Order Body */}
              <div className="p-5">
                <div className="flex gap-4 sm:flex-col">
                  {images.length > 0 && (
                    <div className="flex-shrink-0">
                      <div className="w-24 h-24 sm:w-20 sm:h-20 rounded-lg overflow-hidden border border-gray-200 bg-gray-50 flex items-center justify-center">
                        <img
                          src={images[0] || "/images/placeholder-cake.png"}
                          alt="Product"
                          className="w-full h-full object-cover"
                          onError={(e) => {
                            e.target.src = "/images/placeholder-cake.png";
                          }}
                        />
                      </div>
                    </div>
                  )}

                  <div className="flex-1">
                    {products.map((product, pIndex) => (
                      <div key={`product-${pIndex}`} className="mb-3">
                        <div className="flex items-start justify-between gap-3 mb-1">
                          <div className="flex-1">
                            <Text className="text-base font-semibold text-gray-900 mb-1">
                              {product.name}
                            </Text>
                            {product.description && (
                              <Text className="text-sm text-gray-600 leading-relaxed">
                                {product.description}
                              </Text>
                            )}
                          </div>
                          <Text className="text-base font-semibold text-gray-900 whitespace-nowrap">
                            <Img
                              src="/images/Groupsar2.svg"
                              className="w-4 h-4 mr-1 inline-block"
                            /> {CUSTOM.setPrice(product.price)}
                          </Text>
                        </div>
                      </div>
                    ))}

                    <div className="mt-4 space-y-2">
                      <div className="flex items-start gap-2 p-3 bg-gray-100 rounded-lg">
                        <svg 
                          className="w-4 h-4 text-gray-600 mt-0.5 flex-shrink-0" 
                          fill="none" 
                          stroke="currentColor" 
                          viewBox="0 0 24 24"
                        >
                          <path 
                            strokeLinecap="round" 
                            strokeLinejoin="round" 
                            strokeWidth={2} 
                            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" 
                          />
                          <path 
                            strokeLinecap="round" 
                            strokeLinejoin="round" 
                            strokeWidth={2} 
                            d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" 
                          />
                        </svg>
                        <Text className="text-sm text-gray-900 leading-relaxed flex-1">
                          {deliveryAddress}
                        </Text>
                      </div>

                      <div className="flex items-center gap-2">
                        <svg 
                          className="w-4 h-4 text-gray-600 flex-shrink-0" 
                          fill="none" 
                          stroke="currentColor" 
                          viewBox="0 0 24 24"
                        >
                          <path 
                            strokeLinecap="round" 
                            strokeLinejoin="round" 
                            strokeWidth={2} 
                            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" 
                          />
                        </svg>
                        <Text className="text-sm text-gray-900">
                          {CUSTOM.convertDateString(
                            CUSTOM.getDateFromStatusLog(
                              order.orderStatusLogs,
                              order.status
                            ),
                            "dd/MM/yyyy hh:mm a"
                          )}
                        </Text>
                      </div>
                    </div>

                    {cardMessage && (
                      <div className="mt-4 p-3 bg-amber-50 border border-amber-200 rounded-lg">
                        <div className="flex items-start gap-2">
                          <svg 
                            className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" 
                            fill="none" 
                            stroke="currentColor" 
                            viewBox="0 0 24 24"
                          >
                            <path 
                              strokeLinecap="round" 
                              strokeLinejoin="round" 
                              strokeWidth={2} 
                              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" 
                            />
                          </svg>
                          <div className="flex-1">
                            <Text className="text-xs font-semibold text-gray-900 mb-1">
                              {t("cardMessage")}
                            </Text>
                            <Text className="text-sm text-gray-800 leading-relaxed">
                              {cardMessage}
                            </Text>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Order Footer */}
                <div className="mt-5 pt-4 border-t border-gray-100 flex flex-wrap items-center justify-between gap-3">
                  <div className="flex items-center gap-2">
                    <Text className="text-sm font-semibold text-gray-900">
                      {t("totalAmount")}
                    </Text>
                    <Text className="text-lg font-bold text-[#771237]">
                      <Img
                        src="/images/Groupsar.svg"
                        className="w-4 h-4 mr-1 inline-block"
                      /> {CUSTOM.setPrice(order.priceDetails?.total_amount)}
                    </Text>
                  </div>

                  <div className="flex items-center gap-3 flex-wrap">
                    {(order.status === 'completed' || order.status === 'delivered') && (
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          console.log('Download invoice for order:', order.id);
                        }}
                        className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors"
                      >
                        <svg 
                          className="w-4 h-4" 
                          fill="none" 
                          stroke="currentColor" 
                          viewBox="0 0 24 24"
                        >
                          <path 
                            strokeLinecap="round" 
                            strokeLinejoin="round" 
                            strokeWidth={2} 
                            d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" 
                          />
                        </svg>
                        <span className="sm:hidden">{t("invoice")}</span>
                        <span className="hidden sm:inline">{t("invoice")}</span>
                      </button>
                    )}

                    {/* Track History Button - Opens Modal */}
                    <button
                      onClick={(e) => openTrackHistory(order, e)}
                      className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-gray-900 border border-gray-300 rounded-lg hover:border-gray-400 transition-colors"
                    >
                      {t("trackHistory")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </List>

      {/* Track History Modal */}
      <Modal
        open={trackHistoryModal}
        onClose={closeTrackHistory}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
            sx: {
              backdropFilter: "blur(8px)",
              backgroundColor: "rgba(0, 0, 0, 0.4)",
            },
          },
        }}
      >
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full max-w-[550px] bg-[white] rounded-2xl shadow-2xl outline-none">
          {/* Modal Header */}
          <div className="flex items-center justify-between px-6 py-5 border-b border-gray-200">
            <h2 className="text-lg font-semibold text-gray-900 font-['Inter']">
              {selectedOrder ? `${selectedOrder.orderNumber} (${getItemCount(selectedOrder)} items)` : "Track History"}
            </h2>
            <button
              onClick={closeTrackHistory}
              className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
            >
              <svg
                className="w-5 h-5 text-gray-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          {/* Modal Body */}
          <div className="px-6 py-5 font-['Inter']">
            {renderTrackHistory()}
          </div>
        </div>
      </Modal>

      {/* Empty State */}
      {orderData.length == 0 && !apiLoadStatus ? (
        <EmptyListOrder
          paragraph={t("shopNewProductsAndPlaceOrderToTrackTheStatusHereDot")}
        />
      ) : null}

      <style jsx>{`
        .progress-line {
          position: absolute;
          left: 11px;
          top: 24px;
          width: 2px;
          height: calc(100% + 10px);
          z-index: 1;
        }
        
        .progress-line.success {
          background-color: #10b981;
        }
        
        .progress-line.gray {
          background-color: #d1d5db;
        }
        
        .progress-line.error {
          background-color: #ef4444;
        }

        /* Hide progress line for last item */
        .flex:last-child .progress-line {
          display: none;
        }

        /* Custom scrollbar for modal */
        .overflow-y-auto::-webkit-scrollbar {
          width: 6px;
        }
        
        .overflow-y-auto::-webkit-scrollbar-track {
          background: #f1f1f1;
        }
        
        .overflow-y-auto::-webkit-scrollbar-thumb {
          background: #d1d5db;
          border-radius: 3px;
        }
        
        .overflow-y-auto::-webkit-scrollbar-thumb:hover {
          background: #9ca3af;
        }
      `}</style>
    </>
  );
};

export default MyOrdersOrderlist;

/*
// Old simple card layout
<div
  className="bg-white-A700 border border-gray-300 border-solid flex flex-1 flex-col items-center justify-start p-[19px] rounded w-full cursor-pointer"
  key={`keyid-${index}-${Math.random()}`}
  onClick={() =>
    navigate(
      `/my-order-detail/${CUSTOM.base64Encode(items?.id)}`
    )
  }
>
  <div className="flex flex-col gap-2 items-center justify-start w-full">
    <div className="flex md:flex-col flex-row md:gap-2 items-start justify-between w-full">
      <Text className="font-nunitomedium leading-[24.00px] text-base text-black-900">
        {getOrderItemNames(items?.id)}
      </Text>
      <div className="flex md:flex-1 flex-row gap-2 items-end justify-end w-[50%] md:w-full">
        <Text className="font-nunitoregular text-black-900 text-right text-sm">
          <span className="text-black-900 font-normal">
            {t(CUSTOM.statusByKey(items?.status))}{" "}
            {CUSTOM.convertDateString(
              CUSTOM.getDateFromStatusLog(
                items?.orderStatusLogs,
                items?.status
              ),
              "dd/MM/yyyy hh:mm a"
            )}
          </span>
        </Text>
        <Img
          className="h-6 w-6"
          alt="check_circle"
          src={CUSTOM.orderStatusImgages(items?.status)}
        />
      </div>
    </div>
    <div className="flex flex-row sm:gap-10 items-start justify-between w-full">
      <Text className="font-nunitoregular text-base text-black-900">
        {t("sar")}{" "}
        {CUSTOM.setPrice(items?.priceDetails?.total_amount)}
      </Text>
      <div className="flex flex-row gap-2 items-center justify-start w-auto">
        <Text className="font-nunitoregular text-gray-700 text-right text-xs w-auto">
          {items?.orderType?.includes("custom") && items?.deliveryMode == 'pending' ? "Custom" : CUSTOM.ucFirst(items?.deliveryMode) }
        </Text>
        <div className="bg-gray-700 min-w-[4px] h-1 rounded-[50%] mt-1"></div>
        <Text className="font-nunitoregular text-gray-700 text-right text-xs w-auto">
          #{items?.orderNumber}
        </Text>
      </div>
    </div>
  </div>
</div>
*/